'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import urlReformatPhotos from '@alltrails/lightbox/utils/urlReformatPhotos';
import { PhotoHash } from '@/types/shared';
import { useAppSelector } from '@/utils/redux';
import { useLightbox } from './LightboxContext';

const DynamicLightbox = dynamic(() => import('@alltrails/lightbox/components/Lightbox'), { ssr: false });

type Props = {
  photos: PhotoHash[];
};

const LightboxWrapper = ({ photos }: Props) => {
  const { isLightboxOpen, closeLightbox, lightboxStartingIndex } = useLightbox();
  const context = useAppSelector(state => state.context);
  const languageRegionCode = useLanguageRegionCode();
  const [formattedPhotos, setFormattedPhotos] = useState<any[] | null>(null);

  useEffect(() => {
    if (photos && isLightboxOpen) {
      setFormattedPhotos(urlReformatPhotos(photos));
    }
  }, [photos, isLightboxOpen]);

  if (!isLightboxOpen || !formattedPhotos) {
    return null;
  }

  return (
    <DynamicLightbox
      photos={formattedPhotos}
      closeModal={closeLightbox}
      startingIndex={lightboxStartingIndex}
      context={context}
      languageRegionCode={languageRegionCode}
      analyticsReportLocation="location web page"
    />
  );
};

export default LightboxWrapper;
